module.exports = __webpack_public_path__ + "assets/img/icon_action_hide.29027d71.svg";